import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  continentTitle: {
    margin: '3rem 0 1.5rem',
  },
}));
